<template>
	<div class="">
		<div class="topbg flex justb">
			<div class="flex alit" style="margin-top: -15px;">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%87%91%E8%9E%8D%E6%9C%8D%E5%8A%A1/%E6%80%BB%E8%9E%8D%E8%B5%84%E4%BC%81%E4%B8%9A%402x.png"
					alt="" />
				<div class="">
					<div class="rz-num">
						<div class="">97</div>
					</div>
					<div class="rz-title">总融资企业(家)</div>
				</div>
			</div>
			<div class="flex alit" style="margin-top: -15px;">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%87%91%E8%9E%8D%E6%9C%8D%E5%8A%A1/%E8%9E%8D%E8%B5%84%E6%80%BB%E9%87%91%E9%A2%9D%402x.png"
					alt="" />
				<div class="">
					<div class="rz-num">
						<div class="">6.9</div>
					</div>
					<div class="rz-title">融资总金额(亿元)</div>
				</div>
			</div>
			<div class="flex alit" style="margin-top: -15px;">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%87%91%E8%9E%8D%E6%9C%8D%E5%8A%A1/%E9%87%91%E8%9E%8D%E4%BA%A7%E5%93%81%402x.png"
					alt="" />
				<div class="">
					<div class="rz-num">
						<div class="">146</div>
					</div>
					<div class="rz-title">金融产品(个)</div>
				</div>
			</div>
		</div>

		<div class="flex alit" style="margin: 5px 0;">
			<jrEchartsVue style="height: 220px;width: 190px;margin-right: 10px;"></jrEchartsVue>
			<div class="" style="height: 100%;width: 50%;border: 1px solid !important; border-image: linear-gradient(54deg, rgba(1, 194, 255, 1), rgba(1, 194, 255, 0)) 1 1 !important;">
				<table style="height: 180px;">
					<thead>
						<tr style="background-color: rgba(69, 108, 239, 0.3);text-align: center;">
							<td style="width: 40%;">融资产品</td>
							<td style="width: 35%;">融资总金额(亿元)</td>
							<td style="width: 25%;">占比</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="width: 40%;">股权融资</td>
							<td style="width: 35%;">4.6</td>
							<td style="width: 25%;">67%</td>
						</tr>
						<tr>
							<td style="width: 40%;">债权融资</td>
							<td style="width: 35%;">1.5</td>
							<td style="width: 25%;">22%</td>
						</tr>
						<tr>
							<td style="width: 40%;">政府补贴</td>
							<td style="width: 35%;">0.6</td>
							<td style="width: 25%;">8%</td>
						</tr>
						<tr>
							<td style="width: 40%;">创新工具</td>
							<td style="width: 35%;">0.2</td>
							<td style="width: 25%;">3%</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>


	</div>
</template>

<script>
	import jrEchartsVue from './jrEcharts.vue';
	export default {
		components: {
			jrEchartsVue
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style>
	table {
		border-collapse: collapse;
		/* 确保边框合并为一条线 */
		border: 1px solid !important;
		border-image: linear-gradient(54deg, rgba(1, 194, 255, 1), rgba(1, 194, 255, 0)) 1 1 !important;

		width: 100%;
	}

	table,
	th,
	td {
		border: 1px solid rgba(255, 255, 255, 0.1);
		/* 设置边框为1px实线，颜色为黑色 */
	}
</style>
<style scoped lang="scss">
	td {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #FFFFFF;
		text-align: center;
		padding: 5px 0;
	}

	.topbg {
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%87%91%E8%9E%8D%E6%9C%8D%E5%8A%A1/%E9%87%91%E8%9E%8D%E5%A4%B4%E9%83%A8%E8%83%8C%E6%99%AF%402x.png');
		background-size: 100% 80%;
		background-position-y: 13px;
		height: 60px;
		background-repeat: no-repeat;

		img {
			width: 44px;
			height: 44px;
		}

		.rz-title {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 11px;
			color: rgba(68, 193, 239, 1);

		}

		.rz-num {
			height: 22px;
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%87%91%E8%9E%8D%E6%9C%8D%E5%8A%A1/%E9%87%91%E8%9E%8D%E6%95%B0%E5%AD%97%E8%83%8C%E6%99%AF%402x.png');
			background-size: 100% 16px;
			background-repeat: no-repeat;
			background-position-y: 8px;

			div {
				font-family: DIN-BoldItalic, DIN-BoldItalic;
				font-weight: 900;
				font-size: 16px;
				color: #EDFBFF;
				text-align: center;
				font-style: italic;
				background: linear-gradient(90deg, #FFF600 21%, #FFFCA2 83%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}

		}
	}
</style>